import { render, staticRenderFns } from "./contract-view.vue?vue&type=template&id=8754e528"
import script from "./contract-view.vue?vue&type=script&lang=js"
export * from "./contract-view.vue?vue&type=script&lang=js"
import style0 from "./contract-view.vue?vue&type=style&index=0&id=8754e528&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports